import { MEMBER_TYPE, } from "@erp/shared/components/ui/Dialog/MemberSearchDialog/member.types";
import { keyBy } from "es-toolkit";
/**
 * @description 승인 데이터 설정
 * @param phase 승인 단계
 * @param memberInfo 멤버 정보
 */
export const setApprovalBody = ({ phase, memberInfo, }) => {
    const memberInfoMap = keyBy(memberInfo, (member) => member.type);
    const approverInfo = memberInfoMap[MEMBER_TYPE.승인];
    const checkerInfo = memberInfoMap[MEMBER_TYPE.확인];
    const purchaseManagerInfo = memberInfoMap[MEMBER_TYPE.구매담당자];
    const materialManagerInfo = memberInfoMap[MEMBER_TYPE.자재담당자];
    const approvalData = {
        approvalPhase: phase,
        approver: approverInfo?.id || null,
        ...(checkerInfo && {
            checker: checkerInfo?.id || null,
        }),
        ...(purchaseManagerInfo && {
            purchaseManager: purchaseManagerInfo?.id || null,
        }),
        ...(materialManagerInfo && {
            materialManager: materialManagerInfo?.id || null,
        }),
        rejecter: null,
        rejectReason: null,
    };
    return approvalData;
};
export const createPhase = (creater, checker, approver) => {
    if (creater === checker || approver === checker) {
        return "미승인";
    }
    return "미확인";
};
